module.exports = __webpack_public_path__ + "6cbf6ddb941a99f6e48c131ecf160016.svg";